<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import { QuillEditor } from '@vueup/vue-quill';
import { ref, onMounted } from "vue";
import { useForm, Link } from '@inertiajs/vue3';
import Loading from 'vue-loading-overlay';
import Multiselect from '@vueform/multiselect';
import FlatPickr from 'vue-flatpickr-component';

const props = defineProps({
    year: String,
    allHotels: Object,
    allCountries: Object,
    flash: Object,
    hotelData: Object,
    user: Object,
});
let isLoading = ref(false);
let roomtypes = ref([]);
let transfers = ref([]);
const options = props.allHotels;
const nationalityOptions = props.allCountries;
const configBDT = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});
const configBDF = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
    minDate: "today"
});
const configSDT = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});
const configSDF = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
    minDate: "today"
});

function handleBookingDateChange() {
    configBDT.value = {
        ...configBDT.value,
        minDate: PackageAddform.booking_date_from
    };
}

function handleStayDateChange() {
    configSDT.value = {
        ...configSDT.value,
        minDate: PackageAddform.travel_date_from
    };
}

const handleHotelChange = (e) => {
    const hotel_id = e;
    const hotel = props.hotelData.find((item) => item.id == hotel_id);
    roomtypes.value = hotel.rooms;
    transfers.value = hotel.hotel_transfers;
    isLoading.value = true;
    setTimeout(() => {
        isLoading.value = false;
    }, 1000);
};

onMounted(() => {
    const readonlyInput = document.querySelectorAll('input[readonly]');
    readonlyInput.forEach((item) => {
        item.style.backgroundColor = '#eceef14a';
    });
});

const PackageAddform = useForm({
    stay_type: '0',
    meal_type: '',
    hotel_id: '',
    room_type1: '',
    nights_room1: '',
    room_type2: '',
    nights_room2: '',
    hotel_transfer_id: '',
    package_name: '',
    offer_code: '',
    nationalities: [],
    booking_date_from: '',
    booking_date_to: '',
    travel_date_from: '',
    travel_date_to: '',
    single_rate: '',
    double_rate: '',
    extra_adult_rate: '',
    child_rate: '',
    infant_rate: '',
    instant_confirmation: '0',
    description: '',
});

const PackageAddformSubmit = () => {
    PackageAddform.post('/packages/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/css/vue-quill.snow.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "@vueform/multiselect/themes/default.css";
@import 'flatpickr/dist/themes/material_orange.css';
</style>
<template>
    <AppLayout title="Add New Package" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <div class="card mb-4">
                <h5 class="card-header">Create Package</h5>
                <form class="card-body" @submit.prevent="PackageAddformSubmit">
                    <div class="row g-3">
                        <div class="col-md-4">
                            <label for="stay_type" class="form-label"><b>Stay Type</b></label>
                            <select class="form-select" name="stay_type" v-model="PackageAddform.stay_type">
                                <option value="0">Single Stay</option>
                                <option value="1">Split Stay</option>
                            </select>
                        </div>
                        <div class=" col-md-4">
                            <label for="hotel_id" class="form-label"><b>Hotel Name</b></label>
                            <Multiselect v-model="PackageAddform.hotel_id" :options="options" :closeOnSelect="true"
                                :searchable=true :clearOnSelect=false placeholder="Select hotel ..." track-by="name"
                                label="name" @change="handleHotelChange" :required=true />

                        </div>
                        <div class="col-md-4">
                            <label for="meal_type" class="form-label"><b>Meal Type</b></label>
                            <input type="text" class="form-control" name="meal_type" placeholder="Meal Type"
                                v-model="PackageAddform.meal_type"
                                :class="{ 'is-invalid': PackageAddform.errors.meal_type }">
                            <div v-if="PackageAddform.errors.meal_type" class="invalid-feedback">
                                <div v-text="PackageAddform.errors.meal_type">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="room_type1" class="form-label"><b>Room Type</b></label>
                            <select class="form-select" name="room_type1" required="required"
                                v-model="PackageAddform.room_type1">
                                <option value="" disabled="disabled" selected="selected">Select a room type ...
                                </option>
                                <option v-for="rooms in roomtypes" :key="rooms.room_category.id"
                                    :value="rooms.room_category.id">
                                    {{ rooms.room_category.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="nights_room1" class="form-label"><b>Nights in this room type</b></label>
                            <select class="form-select" name="nights_room1" v-model="PackageAddform.nights_room1"
                                required="required">
                                <option value="" disabled="disabled" selected="selected">Select no of nights ...
                                </option>
                                <option value="1">1 Night</option>
                                <option value="2">2 Nights</option>
                                <option value="3">3 Nights</option>
                                <option value="4">4 Nights</option>
                                <option value="5">5 Nights</option>
                                <option value="6">6 Nights</option>
                                <option value="7">7 Nights</option>
                                <option value="8">8 Nights</option>
                                <option value="9">9 Nights</option>
                                <option value="10">10 Nights</option>
                                <option value="11">11 Nights</option>
                                <option value="12">12 Nights</option>
                                <option value="13">13 Nights</option>
                                <option value="14">14 Nights</option>
                                <option value="15">15 Nights</option>
                                <option value="16">16 Nights</option>
                                <option value="17">17 Nights</option>
                                <option value="18">18 Nights</option>
                                <option value="19">19 Nights</option>
                                <option value="20">20 Nights</option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="arrv_hotel_transfer_id" class="form-label"><b>Transfer</b></label>
                            <select class="form-select" name="hotel_transfer_id" v-model="PackageAddform.hotel_transfer_id"
                                required="required">
                                <option value="" disabled="disabled" selected="selected">Select transfer ...
                                </option>
                                <option v-for="transfer in transfers" :key="transfer.id" :value="transfer.id">
                                    {{ transfer.vessel }}</option>
                            </select>
                        </div>

                        <div class="col-md-4" v-if="PackageAddform.stay_type == '1'">
                            <select class="form-select" name="room_type2" v-model="PackageAddform.room_type2">
                                <option value="" disabled="disabled" selected="selected">Select a room type ...
                                </option>
                                <option v-for="rooms in roomtypes" :key="rooms.room_category.id"
                                    :value="rooms.room_category.id">
                                    {{ rooms.room_category.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-4" v-if="PackageAddform.stay_type == '1'">
                            <select class="form-select" name="nights_room2" v-model="PackageAddform.nights_room2">
                                <option value="" disabled="disabled" selected="selected">Select number of nights ...
                                </option>
                                <option value="1">1 Night</option>
                                <option value="2">2 Nights</option>
                                <option value="3">3 Nights</option>
                                <option value="4">4 Nights</option>
                                <option value="5">5 Nights</option>
                                <option value="6">6 Nights</option>
                                <option value="7">7 Nights</option>
                                <option value="8">8 Nights</option>
                                <option value="9">9 Nights</option>
                                <option value="10">10 Nights</option>
                                <option value="11">11 Nights</option>
                                <option value="12">12 Nights</option>
                                <option value="13">13 Nights</option>
                                <option value="14">14 Nights</option>
                                <option value="15">15 Nights</option>
                                <option value="16">16 Nights</option>
                                <option value="17">17 Nights</option>
                                <option value="18">18 Nights</option>
                                <option value="19">19 Nights</option>
                                <option value="20">20 Nights</option>
                            </select>
                        </div>
                    </div>
                    <div class="row g3 mt-4">
                        <div class="col-md-4">
                            <label for="offer_code" class="form-label"><b>Package Name</b></label>
                            <input type="text" class="form-control" name="package_name"
                                v-model="PackageAddform.package_name" placeholder="Package Name">
                        </div>
                        <div class="col-md-4">
                            <label for="offer_code" class="form-label"><b>Offer Code</b></label>
                            <input type="text" class="form-control" name="offer_code" v-model="PackageAddform.offer_code"
                                placeholder="Offer Code">
                        </div>
                        <div class="col-md-4">
                            <label for="nationalities" class="form-label"><b>Nationalities</b></label>
                            <Multiselect v-model="PackageAddform.nationalities" :options="nationalityOptions" mode="tags"
                                :closeOnSelect="false" :searchable=true placeholder="Select allowed countries ..."
                                track-by="name" label="name" :object="true" :required=true />
                        </div>

                    </div>
                    <hr class="my-4 mx-n4">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label for="arrival_date" class="form-label"><b>Booking Date From</b></label>
                            <FlatPickr v-model="PackageAddform.booking_date_from" :config="configBDF" class="form-control"
                                placeholder="Booking Date From" name="booking_date_from"
                                :class="{ 'is-invalid': PackageAddform.errors.booking_date_from }"
                                @change="handleBookingDateChange" />
                            <div v-if="PackageAddform.errors.booking_date_from" class="invalid-feedback">
                                <div v-text="PackageAddform.errors.booking_date_from">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="departure_date" class="form-label"><b>Booking Date To</b></label>
                            <FlatPickr v-model="PackageAddform.booking_date_to" :config="configBDT" class="form-control"
                                placeholder="Booking Date To" name="booking_date_to"
                                :class="{ 'is-invalid': PackageAddform.errors.booking_date_to }" />
                            <div v-if="PackageAddform.errors.booking_date_to" class="invalid-feedback">
                                <div v-text="PackageAddform.errors.booking_date_to">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="arrival_date" class="form-label"><b>Stay Date From</b></label>
                            <FlatPickr v-model="PackageAddform.travel_date_from" :config="configSDF" class="form-control"
                                placeholder="Travel Date From" name="travel_date_from"
                                :class="{ 'is-invalid': PackageAddform.errors.travel_date_from }"
                                @change="handleStayDateChange" />
                            <div v-if="PackageAddform.errors.travel_date_from" class="invalid-feedback">
                                <div v-text="PackageAddform.errors.travel_date_from">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="departure_date" class="form-label"><b>Stay Date To</b></label>
                            <FlatPickr v-model="PackageAddform.travel_date_to" :config="configSDT" class="form-control"
                                placeholder="Travel Date To" name="travel_date_to"
                                :class="{ 'is-invalid': PackageAddform.errors.travel_date_to }" />
                            <div v-if="PackageAddform.errors.travel_date_to" class="invalid-feedback">
                                <div v-text="PackageAddform.errors.travel_date_to">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row g3 mt-4">
                        <div class="col-md-4">
                            <label for="adult_rate" class="form-label"><b>Single Rate</b></label>
                            <input type="number" v-model="PackageAddform.single_rate" step="0.01" name="adult_rate"
                                class="form-control" placeholder="Single Rate" required="required">
                        </div>
                        <div class="col-md-4">
                            <label for="adult_rate" class="form-label"><b>Double Rate</b></label>
                            <input type="number" v-model="PackageAddform.double_rate" step="0.01" name="adult_rate"
                                class="form-control" placeholder="Double Rate" required="required">
                        </div>
                        <div class="col-md-4">
                            <label for="adult_rate" class="form-label"><b>Extra Adult Rate</b></label>
                            <input type="number" v-model="PackageAddform.extra_adult_rate" step="0.01" name="adult_rate"
                                class="form-control" placeholder="Extra Adult Rate" required="required">
                        </div>
                    </div>
                    <div class="row g3 mt-4">
                        <div class="form-group col-md-4">
                            <label for="child_rate" class="form-label"><b>Child Rate</b></label>
                            <input type="number" v-model="PackageAddform.child_rate" step="0.01" name="child_rate"
                                class="form-control" placeholder="Child Rate" required="required">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="infant_rate" class="form-label"><b>Infant Rate</b></label>
                            <input type="number" v-model="PackageAddform.infant_rate" step="0.01" name="infant_rate"
                                class="form-control" placeholder="Infant Rate" required="required">
                        </div>
                    </div>

                    <!-- <div class="row g3 mt-4">
                        <div class="col-md-4">
                            <label for="adult_occupancy" class="form-label"><b>Adult Max Occupancy</b></label>
                            <input type="number" v-model="PackageAddform.adult_occupancy" step="0.01" name="adult_occupancy"
                                class="form-control" placeholder="Adult Max Occupancy" required="required">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="child_occupancy" class="form-label"><b>Child Max Occupancy</b></label>
                            <input type="number" v-model="PackageAddform.child_occupancy" step="0.01" name="child_occupancy"
                                class="form-control" placeholder="Child Max Occupancy" required="required">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="infant_occupancy" class="form-label"><b>Infant Max Occupancy</b></label>
                            <input type="number" v-model="PackageAddform.infant_occupancy" step="0.01"
                                name="infant_occupancy" class="form-control" placeholder="Infant Max Occupancy"
                                required="required">
                        </div>
                    </div> -->

                    <div class="row g3 mt-4">
                        <div class="form-group col-md-4">
                            <label for="adult_occupancy" class="form-label"><b>Instantly Confirmed</b></label>
                            <select class="form-select" v-model="PackageAddform.instant_confirmation"
                                name="instant_confirmation" id="instant_confirmation" data-live-search="true"
                                required="required">
                                <option value="0">No</option>
                                <option value="1">Yes</option>
                            </select>
                        </div>
                    </div>

                    <hr class="my-4 mx-n4">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <label for="description" class="form-label"><b>Package Description</b></label>
                            <QuillEditor theme="snow" v-model:content="PackageAddform.description" contentType="html"
                                toolbar="essential" object="true" :searchable="true" name="remarks" />
                        </div>
                    </div>
                    <div class="modal-footer border-0 mt-3">
                        <Link type="button" class="btn btn-label-secondary" :href="'/packages'">
                        Cancel
                        </Link>
                        <button type="submit" class="btn btn-primary me-sm-3 me-1"
                            :disabled="PackageAddform.processing">Create Package</button>
                    </div>
                </form>
            </div>
        </div>
    </AppLayout>
</template>